$(document).on('change', '#contact_region', function() {
  $.get('/help/contact-info', { region: $(this).val() }, function(data) {
    $('.contact-info').html(data)
  })
})
